export enum TrackingEvent {
  ShortcutUsed = 'Shortcut used',
}

export const SHORTCUTS_TAGS_TEST_ID = 'shortcuts-tags-test-id';
